import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TransactionsService } from '../transactions.service';

@Component({
  selector: 'app-transactions-error',
  templateUrl: './transactions-error.component.html',
  styleUrls: ['./transactions-error.component.css']
})
export class TransactionsErrorComponent implements OnInit, OnDestroy {

  errorMessage: string;
  transactionErrorSubscription : Subscription;

  constructor(private transactionsService : TransactionsService) { 
    this.transactionErrorSubscription = this.transactionsService.notifyTransactionsError
    .subscribe(data=>{
      this.errorMessage=data;
    })
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.transactionErrorSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/transactions/transactions-error/transactions-error.component.ts